import Vue from "vue";
import Vuex from "vuex";
import Toasted from "vue-toasted";

import * as Sentry from "@sentry/vue";
import { getAppCustomEnv } from "@sleek/customer-common-acquisition";

Vue.use(Toasted);
Vue.use(Vuex);
import singleSpaVue from "single-spa-vue";
import Cookies from "js-cookie";

const isProd = window.location.hostname.includes("app.");
const isLocalhost = window.location.hostname.includes("localhost");

if (isLocalhost === false) {
  Sentry.init({
    Vue,
    dsn: "https://dc0687be41db6650775803a05848050a@o220456.ingest.sentry.io/4506228024672256",
    attachProps: true,

    tracesSampleRate: 1.0, // Set the sample rate for transactions
    environment: isProd ? "production" : "development", // Set the environment
  });
}

const getAppBaseUrl = async () => {
  const appCustomEnv = await getAppCustomEnv();
  return appCustomEnv.VUE_APP_PLATFORM_APP_URL;
};

const updateFavicon = async () => {
  let src = `${await getAppBaseUrl()}/favicon.png`;

  src = src + "?=" + Math.random();
  var link = document.createElement("link"),
    oldLink = document.getElementById("dynamic-favicon");
  link.id = "dynamic-favicon";
  link.rel = "icon";
  link.href = src;
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
};

updateFavicon();

import App from "./App.vue";
import router from "./routes";
import store from "@/store";

import VueI18n from "vue-i18n";

import enMessages from /* webpackChunkName: "lang" */ "@/lang/en";
import sgMessage from /* webpackChunkName: "lang" */ "@/lang/sg";
import auMessage from /* webpackChunkName: "lang" */ "@/lang/au";
import ukMessage from /* webpackChunkName: "lang" */ "@/lang/uk";
import zhMessage from /* webpackChunkName: "lang" */ "@/lang/zh";

Vue.use(VueI18n);

let locale = "en";

const getLangMessages = () => {
  let message = { ...enMessages };

  const domain = window.location.hostname;
  const domainParts = domain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];

  console.log(topLevelDomain, "topLevelDomain");

  const isSg = topLevelDomain === "sg" || domain.includes("sg-app");
  const isUk = topLevelDomain === "uk" || domain.includes("uk-app");
  const isAu = domain.includes("au-app");
  const isHk = topLevelDomain === "hk";

  // Temp workaround, to pre-load the languages into the
  if (isSg) {
    // loadedLanguages = ["en", "sg"]; // our default language that is preloaded
    locale = "sg";
    message = { en: { ...enMessages.en }, sg: sgMessage };
  }

  if (isUk) {
    // loadedLanguages = ["en", "uk"]; // our default language that is preloaded
    locale = "uk";
    message = { en: { ...enMessages.en }, uk: ukMessage };
  }

  if (isAu) {
    // loadedLanguages = ["en", "au"]; // our default language that is preloaded
    locale = "au";
    message = { en: { ...enMessages.en }, au: auMessage };
  }

  if (isHk) {
    const params = new URLSearchParams(window.location.search);
    const langKey = params.get("lang");
    if (langKey == "HK" || langKey == "hk") {
      locale = "zh";
    } else {
      locale =
        Cookies.get("_acquisition_lang") !== "zh" &&
        Cookies.get("_acquisition_lang") !== "en"
          ? "en"
          : Cookies.get("_acquisition_lang");
    }
    message = { en: { ...enMessages.en }, zh: zhMessage };
  }

  console.log("locale", message, locale);

  return message;
};

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: locale, // set locale
  fallbackLocale: "en",
  formatFallbackMessages: true,
  messages: getLangMessages(),
});

Vue.config.devtools = !window.location.hostname.includes("app.");
Vue.config.productionTip = true;
// disable warning
Vue.config.silent = false;

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h) {
      return h(App, {
        props: {
          // single-spa props are available on the "this" object. Forward them to your component as needed.
          // https://single-spa.js.org/docs/building-applications#lifecycle-props
          // if you uncomment these, remember to add matching prop definitions for them in your App.vue file.
          /*
          name: this.name,
          mountParcel: this.mountParcel,
          singleSpa: this.singleSpa,
          */
        },
      });
    },
    router,
    store,
    i18n,
  },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;

const getNudgifyKey = async () => {
  const domain = window.location.hostname;
  const domainParts = domain.split(".");
  const topLevelDomain = domainParts[domainParts.length - 1];
  const isUk = topLevelDomain === "uk" || domain.includes("uk-app");
  const isLtdUK = domain.includes("ltd");
  const appCustomEnv = await getAppCustomEnv();

  if (isUk && isLtdUK) {
    return appCustomEnv.VUE_NUDGIFY_KEY_LTD;
  }

  return appCustomEnv.VUE_NUDGIFY_KEY;
};

(async function (w) {
  var k = "nudgify",
    n = w[k] || (w[k] = {});
  n.uuid = await getNudgifyKey();
  var d = document,
    s = d.createElement("script");
  s.src = "https://pixel.nudgify.com/pixel.js";
  s.async = true;
  s.charset = "utf-8";
  d.getElementsByTagName("head")[0].appendChild(s);
})(window);
